import { render, staticRenderFns } from "./SaveProductForm.vue?vue&type=template&id=13342f56&"
import script from "./SaveProductForm.vue?vue&type=script&lang=js&"
export * from "./SaveProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports